import Resource from '@/api/resources/Resource'

class IncidentOriginServices extends Resource {
    async findAllActiveOrigins(laboratoryId, coreEntity) {
        const params = { coreEntity }
        const response = await this.axios.get(`/incident/laboratories/${laboratoryId}/incidentOrigins`, { params })
        return response.data.reduce((map, incidentOrigin) => {
            map[incidentOrigin.id] = incidentOrigin
            return map
        }, {})
    }
}
export default new IncidentOriginServices()
